import React, { useState } from "react"
import IdentifyingGA from "./identifyingGA"
import CurrentChallenge from "./currentChallenge"
import ImpactOnPatients from "./impactOnPatients"
import ComplementPathway from "./complementPathway"
import { ChildTabsComponent } from "../components"
import { useTranslation } from "react-i18next"
import TransMsg from "./transMessage"

const AboutGA = () => {
  const { t } = useTranslation()
  const [aboutTabValue, setAboutTabValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setAboutTabValue(newValue);
  };

  const aboutGATabs = [
    {
      tabLabel: t(TransMsg.IDENTIFYING_GA_LABEL),
      children: <IdentifyingGA />
    },
    {
      tabLabel: t(TransMsg.CURRENT_CHALLENGE_LABEL),
      children: <CurrentChallenge />
    },
    {
      tabLabel: t(TransMsg.PATIENT_IMPACTS_LABEL),
      children: <ImpactOnPatients />
    },
    {
      tabLabel: t(TransMsg.COMPLEMENT_PATHWAY_LABEL),
      children: <ComplementPathway />
    }
  ]

  return (
    <ChildTabsComponent
      tabsList={aboutGATabs}
      value={aboutTabValue}
      handleChange={handleChange}
    />
  )
}

export default AboutGA